<div class="col-grid">
  <div *ngFor="let timeCell of timeRange" class="grid-cell"></div>
</div>

<ng-container *ngIf="!isLoading && data && data.ranges.length">
  <ng-container *ngFor="let range of data?.ranges">
    <app-schedule-range
      *ngIf="range.slots && range.slots.length"
      [slots]="range.slots"
      [range]="range.range"
      [startPosition]="range.range[0] - timeRange[0]"
      [homeMode]="homeMode"
      [onlineClassText]="onlineClassText"
      [cancelledClassText]="cancelledClassText"
      [hibridClassText]="hibridClassText"
      [notificationsHeaderText]="notificationsHeaderText"
    />
  </ng-container>
</ng-container>

<div *ngIf="showFullNoResult && !isLoading && (!data || !data.ranges.length)" class="empty-box">
  <mat-icon [svgIcon]="'empty'" class="empty-icon"></mat-icon>
  <h4 class="empty-title">{{noResultsTitle}}</h4>
  <div *ngIf="noResultsContent" class="empty-text" [innerHTML]="noResultsContent"></div>
  <a *ngIf="noResultsLink" href="{{noResultsLink}}" class="empty-btn btn-md" mat-flat-button color="primary" target="_blank">
    {{noResultsLinkText}}
  </a>
</div>

<div *ngIf="!showFullNoResult&& !isLoading && (!data || !data.ranges.length)" class="empty-box d-not-phone-none">
  <h4 class="empty-title">{{noResultsTitle}}</h4>
  <div *ngIf="noResultsContent" class="empty-text" [innerHTML]="noResultsContent"></div>
</div>

<div *ngIf="isLoading" class="empty-box">
  <div class="preloader--mini">
    <div class="preloader__icon">
        <img alt="" height="50" loading="lazy" src="Content/Images/icons/preloader.png?format=webp" width="50">
      </div>
  </div>
</div>